
import { defineComponent, onBeforeUnmount, ref, Ref } from 'vue'
import { Map, VectorLayer, Marker, Coordinate } from 'maptalks'
import AppHeader from '@/components/Header.vue'
import getMapSiteInfo from '@/compositions/map/index'
import { Toast, ActionSheet } from 'vant'
import { NetworkPointItem } from '@/types/device-replace'
import { getMap } from '@/utils/maptalkFactory'
import { GetNetworkpointDetail } from '@/apis/fault'
import { ComponentInstance } from 'vant/lib/utils'
import getRoute from '@/compositions/route'
import appHost from '@/utils/app'

export default defineComponent({
  name: 'warehouse-Pointdetail',
  components: {
    AppHeader,
    VanActionSheet: ActionSheet,
  },
  setup() {
    const { params: routeParams, query } = getRoute()
    const show: Ref<boolean> = ref(false)
    const actions = [{ name: '苹果地图' }, { name: '高德地图' }]
    const box = ref<HTMLElement>()
    let { mapSite, mapZoom, mapCenter } = getMapSiteInfo()
    let _layer: VectorLayer = null
    let map: Map = null
    const item: Ref<NetworkPointItem> = ref(null)
    let _ts: number = Date.now()
    let toast: ComponentInstance = null
    item.value = {
      company_name: routeParams.value.company_name as string,
      phone: routeParams.value.phone as string,
      icc: routeParams.value.icc as string,
      area: routeParams.value.area as string,
      address: routeParams.value.address as string,
      longitude: routeParams.value.longitude as string,
      latitude: routeParams.value.latitude as string,
    }
    console.log('item.value', item.value)
    onBeforeUnmount(() => {
      if (toast) {
        toast.clear()
        toast = null
      }
      _ts = 0
    })

    return {
      show,
      actions,
      mapSite,
      mapZoom,
      mapCenter,
      map,
      box,
      item,
      _layer,
    }
  },
  watch: {
    item() {
      if (this.item && !this._layer && this.map) {
        this.drawSite()
      }
    },
  },
  mounted() {
    this.map = getMap(this.box, {
      center: this.mapCenter,
      zoom: this.mapZoom,
      attribution: false,
    })
    this.$nextTick(() => {
      if (this.item && !this._layer) {
        this.drawSite()
      }
    })
  },
  beforeUnmount() {
    this.clearLayer()
    this.removeLayer()
    if (this.map) this.map.remove()
  },
  methods: {
    onCallPoint(): void {
      const phone = this.item?.phone || ''
      appHost.postCallPhone(phone.trim(), this.item?.company_name)
    },
    onNavigatePoint(): void {
      const { address = '', longitude: lng = '0', latitude: lat = '0' } = this.item
      appHost.postMapNavigation({ address, lng: Number(lng), lat: Number(lat) })
    },
    clearLayer(): void {
      if (this._layer) this._layer.clear()
    },
    removeLayer(): void {
      if (this._layer) {
        this._layer.remove()
        this._layer = null
      }
    },
    drawSite(): void {
      this.createLayer()
      this.clearLayer()
      if (!this._layer || !this.map) return
      const { latitude: lat = '0', longitude: lng = '0' } = this.item
      const point: number[] = [Number(lng), Number(lat)]
      const marker: Marker = new Marker(point, {
        id: Date.now().toString(),
        editable: false,
        interactive: false,
        symbol: {
          markerFile: '/images/icon_weizhi.png',
          markerWidth: 40,
          markerHeight: 40,
          scale: 1,
        },
      })
      this._layer.addGeometry(marker)
      this.map.setCenter(new Coordinate(point))
    },
    createLayer(): void {
      if (!this._layer && this.map)
        this._layer = new VectorLayer(Date.now().toString()).addTo(this.map)
    },
  },
})
